module.exports = __webpack_public_path__ + "img/icon_likes.3d930668.svg";